import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resource, calendarHolidays }) => {
    return present(
      repository
        .assignCalendarHolidaysToResource(resource, calendarHolidays)
        .then((savedResource) => ({
          resource: savedResource,
          calendarHolidays,
        }))
        .catch(() => Promise.reject({ resource, calendarHolidays })),
    );
  };
}

export type { Interactor };

export { createInteractor };
